import { render, staticRenderFns } from "./ContactusList.vue?vue&type=template&id=4396d357"
import script from "./ContactusList.vue?vue&type=script&lang=js"
export * from "./ContactusList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports